import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import type React from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { getSavedMethod } from '../../../utils/cashier';

const usePaymentMethodVerification = (): boolean => {
  const {
    data: { savedCardInfoId, savedCards, depositResultContext }
  } = useWizardContext();
  const license = useSelector(select.account.getLicense);

  const isPaymentMethodVerificationRequired = () => {
    if (!savedCards || savedCards.length === 0 || (savedCards?.length && !savedCardInfoId)) {
      return true;
    } else if (savedCards?.length && savedCardInfoId) {
      const [{ savedCard }] = getSavedMethod(savedCards, savedCardInfoId);
      return savedCard && !savedCard.verified;
    }
    return false;
  };

  return (
    [LicenceId.DE, LicenceId.PORTUGAL].includes(license) &&
    isPaymentMethodVerificationRequired() &&
    !depositResultContext?.transactionInfo?.paymentVerified
  );
};

export default usePaymentMethodVerification;
